export function addProducts(state, data) {
  state.products = data;
}
export function addAddress(state, data) {
  state.addressId = data;
}
export function addInvoice(state, data) {
  state.invoiceId = data;
}
export function addId(state, data) {
  state.id = data;
}
export function addCard(state, data) {
  state.card = data.card;
  state.deviceSession = data.deviceSession;
}
export function clean(state) {
  state = {
    products: [],
    addressId: null,
    invoiceId: null,
    deliveryCompany: 'FEDEX',
    orderId: null,
    card: {
      name: null,
      cardNumber: null,
      expirationMonth: null,
      expirationYear: null,
      securityCode: null,
      payments: null
    },
    deviceSession: null
  };
}
export function items(state, data) {
  state.items = data;
}